module.exports = __webpack_public_path__ + "static/media/wrong.158e2549.mp3";